import { useCallback, useState } from 'react';
import { useClient } from '../../../../context/client';
import { alertsManager } from '../../../../utils';
import { ORDER_ACTIONS } from './useOrderEditState';

export function useSaveOrder() {
	const [isLoading, setIsLoading] = useState(false);
	const client = useClient();

	const dispatch = useCallback(
		async (orderData, orderDispatch) => {
			setIsLoading(true);

			const serializedOrder = JSON.parse(JSON.stringify(orderData));
			serializedOrder.custom.products =
				serializedOrder.custom.products.map((product) => ({
					...product,
					sub_model:
						product.sub_model !== '' ? product.sub_model : null,
				}));
			serializedOrder.custom.tags = serializedOrder.tags;
			serializedOrder.custom.sub_tags = serializedOrder.childTags;
			serializedOrder.order.custom_status = serializedOrder.order.status;
			serializedOrder.order.shipping_addresses =
				serializedOrder.order.shippingAddresses;
			delete serializedOrder.order.shippingAddresses;

			try {
				if (serializedOrder.custom.products.length <= 0) {
					alertsManager.add({
						type: 'warning',
						autoDismiss: true,
						messages: [
							{ text: 'Orders must contain at least 1 product' },
						],
					});
					return false;
				}

				const updatedOrder = await client.updateOrder(
					serializedOrder.order.id,
					serializedOrder.order,
					serializedOrder.custom,
				);

				if (updatedOrder && orderDispatch) {
					orderDispatch({
						type: ORDER_ACTIONS.UPDATE_ORDER_SUCCESS,
						data: updatedOrder,
					});
				}

				alertsManager.add({
					type: 'success',
					autoDismiss: true,
					messages: [{ text: 'Order Saved' }],
				});
				return true;
			} catch (err) {
				console.error(err);

				alertsManager.add({
					type: 'error',
					header: 'Server Error',
					messages: [{ text: 'Error, please reload and try again.' }],
				});
				return false;
			} finally {
				setIsLoading(false);
			}
		},
		[client],
	);

	return [isLoading, dispatch];
}
